<template>
  <div class="app-container">
    <header class="app-header">
      <div class="header-content">
        <div class="logo-container">
          <img src="./assets/logo.png" alt="GREEN AI TECH" class="company-logo">
        </div>
        <div class="title-container">
          <h1 class="app-title">智能表格識別系統</h1>
          <p class="app-subtitle">智能化的表格識別系統，讓數據提取更快速、更精準</p>
        </div>
      </div>
    </header>
    <main class="main-content">
      <div class="nav-menu">
        <router-link to="/table" class="nav-item" active-class="active">
          <i class="el-icon-document"></i> 表格識別
        </router-link>
        <router-link to="/excel" class="nav-item" active-class="active">
          <i class="el-icon-edit-outline"></i> Excel編輯
        </router-link>
      </div>
      <div class="content-container">
        <router-view></router-view>
      </div>
    </main>
          <footer class="app-footer">
        <div class="footer-content">
          <p class="company-intro">GREEN AI TECH 專注於人工智能視覺識別技術，為企業提供高效的文檔數位化解決方案。</p>
          <p class="contact-info">聯絡方式：colalam@greenaitech.com</p>
          <p class="copyright">© 2025 GREEN AI TECH - AI Powered Document Processing</p>
        </div>
      </footer>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* 重置默認樣式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  line-height: 1.6;
  color: #2c3e50;
  background-color: #f5f7fa;
}

.app-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.app-header {
  padding: 20px;
  background: #fff;
  color: #2c3e50;
  margin-bottom: 40px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 20px;
}

.logo-container {
  flex-shrink: 0;
}

.company-logo {
  height: 60px;
  width: auto;
}

.title-container {
  text-align: left;
}

.app-title {
  font-size: 2em;
  font-weight: 600;
  margin-bottom: 8px;
  color: #006838; /* GREEN AI TECH的主色調 */
}

.app-subtitle {
  font-size: 1.1em;
  color: #666;
  max-width: 600px;
}

.main-content {
  flex: 1;
  padding: 0 20px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.nav-menu {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  background: #fff;
  padding: 10px 20px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 10px 20px;
  color: #606266;
  text-decoration: none;
  border-radius: 4px;
  transition: all 0.3s;
}

.nav-item:hover {
  color: #409EFF;
  background: #f5f7fa;
}

.nav-item.active {
  color: #409EFF;
  background: #ecf5ff;
}

.nav-item i {
  font-size: 18px;
}

.content-container {
  flex: 1;
  min-height: 500px;
}

.app-footer {
  padding: 30px 20px;
  background-color: #fff;
  color: #606266;
  margin-top: 40px;
  box-shadow: 0 -2px 12px 0 rgba(0,0,0,0.05);
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
}

.company-intro {
  font-size: 1em;
  line-height: 1.6;
  color: #2c3e50;
  margin-bottom: 15px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.contact-info {
  font-size: 0.9em;
  color: #606266;
  margin-bottom: 10px;
}

.copyright {
  font-size: 0.9em;
  color: #909399;
}
</style>